kombi.selectRooms = function(button) {
    if (!button) {
        return;
    }

    const accordion = document.getElementById('accordionResulOccupation');
    if (accordion) {
        accordion.scrollIntoView({ behavior: 'smooth', block: 'start' });
        const firstItem = accordion.querySelector('.accordion-collapse');
        if (firstItem && !firstItem.classList.contains('show')) {
            new bootstrap.Collapse(firstItem, { toggle: true });
        }
    }

    const switchButtons = button.closest('#switch-buttons');
    const cartButton = switchButtons.querySelector('#cart-button');
    if(cartButton) {
        button.classList.add('d-none')
        cartButton.classList.remove('d-none');
    }
}

kombi.highlightElement = function() {
    const el = document.querySelector(".d-sm-block .nav-search");
    el.classList.add("highlight");
    
    setTimeout(() => {
      el.classList.remove("highlight");
    }, 2000);
}

kombi.clearSearchField = function(field) {
    if (field == "guests") {
        const clearGuestsButtons = document.querySelectorAll(".clear-guests .closeIcon")
        clearGuestsButtons.forEach(button => {
            button.click()
        })    
    } else {
        const clearCalendarButtons = document.querySelectorAll(".clear-calendar")
        clearCalendarButtons.forEach(button => {
            button.click()
        })
    }
}
kombi.hideCartToast = function() {
    const cartToast = document.getElementById("cart-toast");
    cartToast?.classList.add("d-none");
}

kombi.suppressCartToast = function() {
    const cartToast = document.getElementById("cart-toast");
    if (!cartToast) return;

    cartToast.dataset.displayToast = "false";
    kombi.hideCartToast();
}

kombi.changeSearch = function(field, options) {
    if (field && typeof field === "object") {
        options = field;
        field = undefined;
    }
    options = options || {};

    if (options.suppressCartToast) {
        kombi.suppressCartToast();
    }
    
    kombi.clearSearchField(field)

    const offcanvasEl = document.querySelector("#malaOffcanvas")
    const offcanvas = bootstrap.Offcanvas.getOrCreateInstance(offcanvasEl);

    if (offcanvasEl.classList.contains("show")) {
        offcanvas.hide()
    }

    kombi.closeModal('malaModal');

    window.scrollTo({
        top: 0,
    }); 

    if (window.matchMedia("(min-width: 992px)").matches) {
        kombi.highlightElement();     
        if (field != "guests") {
            const checkIfAtTop = () => {
                if (window.scrollY <= 5) {
                    kombi.openDatePicker();
                } else {
                    requestAnimationFrame(checkIfAtTop);
                }
            };    
            requestAnimationFrame(checkIfAtTop);
        }
    } else {
        const modalElement = document.getElementById("SearchForm")
        let modalInstance = bootstrap.Modal.getInstance(modalElement)
        if (!modalInstance) {
            modalInstance = new bootstrap.Modal(modalElement)
        }
        if (field != "guests") {
            const showDatePickerAfterModal = () => {
                kombi.openDatePicker();
                modalElement.removeEventListener("shown.bs.modal", showDatePickerAfterModal);
            };
            const checkIfAtTop = () => {
                if (window.scrollY <= 5) {
                    modalElement.addEventListener("shown.bs.modal", showDatePickerAfterModal);
                    modalInstance.show();
                } else {
                    requestAnimationFrame(checkIfAtTop);
                }
            };
            requestAnimationFrame(checkIfAtTop);
        }
    }      
}

kombi.isTravelSuitcaseOpen = function () {
    const malaOffcanvas = document.getElementById("malaOffcanvas");
    const malaModal = document.getElementById("malaModal");
    return (
        !!(malaOffcanvas && malaOffcanvas.classList.contains("show")) ||
        !!(malaModal && malaModal.classList.contains("show"))
    );
};

kombi.showCartToastIfFull = function() {
    const cartToast = document.getElementById("cart-toast");
    if (!cartToast) return;
    // afterOnLoad can race with cart:open-offcanvas (afterSettle)
    if (kombi.isTravelSuitcaseOpen()) return;

    const isCartFull = cartToast.dataset.isCartFull === "true";
    const dataDisplay = cartToast.dataset.displayToast === "true";
    if (isCartFull && dataDisplay) {
        cartToast.classList.remove("d-none");
    }
}

kombi.travelSuitcaseNavLinkMobile = function() {
    // Delegate on body: #travel-suitcase innerHTML swap replaces #malaOffcanvas,
    // so listeners on the element itself would be lost after bindOnce.
    kombi.lifecycle.bindOnce("travel-suitcase-mobile", function () {
        const EXTRA_MODALS =
            "#PackageModal, #PackageModalMoreThan9Guests, [id^=\"FlightModal\"]";

        function isExtraModal(el) {
            return !!(el && el.matches && el.matches(EXTRA_MODALS));
        }

        function getMalaNav() {
            const malaLink = document.querySelector(
                '.nav-link[data-bs-target="#malaOffcanvas"]'
            );
            return {
                malaLink: malaLink,
                statusColor: malaLink?.querySelector(".status-color"),
            };
        }

        document.body.addEventListener("shown.bs.offcanvas", function (event) {
            if (event.target.id !== "malaOffcanvas") return;
            const nav = getMalaNav();
            nav.malaLink?.classList.add("active");
            nav.statusColor?.classList.add("d-none");
            kombi.hideCartToast();
        });

        document.body.addEventListener("hidden.bs.offcanvas", function (event) {
            if (event.target.id !== "malaOffcanvas") return;
            const nav = getMalaNav();
            nav.malaLink?.classList.remove("active");
            nav.statusColor?.classList.remove("d-none");
            kombi.showCartToastIfFull();
        });

        document.body.addEventListener("shown.bs.modal", function (event) {
            if (!isExtraModal(event.target)) return;
            kombi.hideCartToast();
        });

        document.body.addEventListener("hidden.bs.modal", function (event) {
            if (!isExtraModal(event.target)) return;
            kombi.showCartToastIfFull();
        });
    });
}

kombi.travelSuitcaseNavLinkDesktop = function() {
    // Delegate on body: #travel-suitcase swap recreates #malaModal.
    // Extra modals toast hide/show is already handled by travelSuitcaseNavLinkMobile.
    kombi.lifecycle.bindOnce("travel-suitcase-desktop", function () {
        function getMalaNav() {
            const malaItem = document.querySelector(
                'li[data-bs-target="#malaModal"]'
            );
            return {
                malaItem: malaItem,
                statusColor: malaItem?.querySelector(".status-color"),
            };
        }

        document.body.addEventListener("shown.bs.modal", function (event) {
            if (event.target.id !== "malaModal") return;
            const nav = getMalaNav();
            nav.malaItem?.classList.add("text-primary");
            nav.statusColor?.classList.add("d-none");
            kombi.hideCartToast();
        });

        document.body.addEventListener("hidden.bs.modal", function (event) {
            if (event.target.id !== "malaModal") return;
            const nav = getMalaNav();
            nav.malaItem?.classList.remove("text-primary");
            nav.statusColor?.classList.remove("d-none");
            kombi.showCartToastIfFull();
        });
    });
}